export const AIRLINE_NAMES_FOR_CARRIER_CODE = {
  ZO: 'Airblue',
  TZ: 'Air Tanzania',
  TK1: 'Turkish Airlines',
  EK1: 'Emirates Airlines',
  PC: 'Emirates Airlines',
  EA: 'Pegasus Airlines',
  EB: 'European Air Express',
  EC: 'Pullmantur Air',
  DT: 'Openskies',
  E7: 'TAAG Angola Airlines',
  DV: 'Fly European',
  DW: 'Air Company SCAT',
  DX: 'Aero-Charter',
  DAT: 'Danish Air Transport',
  DM: 'Norwegian Air Shuttle',
  DL: 'Sterling Blue',
  DN: 'Delta Air Lines',
  DQ: 'Air Deccan',
  DP: 'Costal Air Transport',
  E4: 'First Choice Airways',
  DR: 'Aero Asia International',
  DE: 'Air Link Pty Ltd',
  DD: 'Condor Flugdienst',
  DG: 'NOK Airlines',
  DF: 'Cebgo',
  DH: 'Aebal',
  DJ: 'Independence AIr',
  FD: 'Virgin Blue',
  FE: 'Thai AirAsia',
  FB: 'Primaris Airlines',
  FC: 'Bulgaria Air',
  F8: 'Finnish Commuter Airlines',
  EW: 'Freedom Airlines',
  F9: 'Eurowings AG',
  EX: 'Frontier Airlines',
  EU: 'Air Santo Domingo',
  EV: 'Ecuatoriana',
  F7: 'Atlantic Southeast Airlines',
  EY: 'Flybaboo',
  EZ: 'Etihad',
  EP: 'Sun Air of Scandinavia',
  EO: 'Iran Assemam Airlines',
  EN: 'Hewa Bora Airways',
  EM: 'Air Dolomiti S P A',
  ET: 'Aero Benin',
  ET1: 'Ethiopian Air Lines',
  ES: 'Ethiopian Air Lines',
  F3: 'DHL International',
  EH: 'Fly Excellent',
  EF: 'Air Nippon Network',
  EE: 'Far Eastern Air Transport',
  EK: 'Aero Airlines',
  EJ: 'Emirates Airlines',
  EI: 'New England Airlines',
  GE: 'Aer Lingus P.L.C.',
  GF: 'TransAsia Airways',
  GA: 'Gulf Air',
  FZ: 'Garuda Indonesian',
  FZ1: 'Fly Dubai',
  FZ2: 'Fly Dubai',
  FV: 'Fly Dubai',
  FW: 'Rossiya- Russian Airlines',
  G8: 'Go Airways',
  G9: 'GoFirst',
  FY: 'Air Arabia',
  G4: 'Firefly',
  FS: 'Allegiant Air',
  G3: 'Itali Airlines',
  FR: 'Gol Transportes Aereos',
  G6: 'RyanAir (Ireland)',
  FT: 'Angkor Airways Corporation',
  G5: 'Siem Reap Airways International',
  FN: 'China Express Airlines',
  FQ: 'Regional Air Lines (Morocco)',
  FP: 'Brindabella Airlines',
  FK: 'Freedom Air (Guam)',
  FJ: 'Keewatin Air',
  FM: 'Air Pacific Limited',
  FL: 'Shanghai Airlines',
  FG: 'Airtran Airways Inc',
  FI: 'Ariana Afghan Airlines',
  FH: 'Icelandair',
  HG: 'Futura International Airways',
  HD: 'Niki Luftfahrt',
  HE: 'Hokkaido International Airlines',
  HB: 'LGW',
  HA: 'Homer Air',
  GY: 'Hawaiian Airlines',
  GZ: 'Gabon Airlines',
  GW: 'Air Rarotonga',
  GX: 'Kuban Airline',
  H9: 'JetX',
  GV: 'Himalaya Airlines',
  H7: 'Grant Aviation',
  H6: 'Eagle Aviation Uganda',
  GU: 'Hageland Aviation Services',
  GT: 'Aviateca',
  H4: 'GB Airways',
  GS: 'Heli Securite',
  GR: 'Grand China Express',
  H2: 'Aurigny Air Services',
  GP: 'Sky Airline',
  GM: 'Gadair',
  GL: 'Air Slovakia',
  GI: 'Air Greenland',
  A4: 'Itek Air',
  A3: 'Southern Winds S.A.',
  A6: 'Aegean Air',
  A5: 'Air Alps',
  A8: 'Airlinair',
  A9: 'Benin Golf Air',
  A0: 'Georgian Airways',
  AT: 'L Avion Elysair',
  AT1: 'Royal Air Maroc',
  AS: 'Royal Air Maroc',
  AR: 'Alaska Airlines',
  B2: 'Aerolineas Argentinas',
  AX: 'Belavia',
  B8: 'American Connection',
  AV: 'Eritrean Airlines',
  B7: 'Avianca',
  AU: 'Uni Airways Corp.',
  B6: 'Austral Lineas Aerea',
  AZ: 'JetBlue Airways',
  AY: 'Alitalia',
  BA: 'Finnair',
  BA1: 'British Airways',
  AC: 'Air Canada',
  AA: 'American Airlines',
  AB: 'Air Berlin',
  AB1: 'Air Berlin',
  AH: 'Air Algerie',
  AF: 'Air France',
  AK: 'AirAsia',
  AL: 'Skyway Airlines',
  AI: 'Air India',
  AI1: 'Air India',
  AJ: 'Aerocontractors',
  AP: 'Air One',
  AM: 'Aeromexico',
  BW: 'Caribbean Airlines',
  C8: 'NAC Air LP',
  BV: 'Blue Panorama Airlines',
  BY: 'Thomsonfly',
  C9: 'Cirrus Airlines',
  BS: 'US-Bangla Airlines',
  BR: 'EVA Airways Corporation',
  C3: 'Contact Air',
  C6: 'Canjet Airlines',
  BU: "COMPAGNIE AFRICAINE D'AVIATION",
  BT: 'Air Baltic',
  C5: 'CommutAir',
  CB: 'ScotAirways',
  CA: 'Air China',
  BZ: 'KEYSTONE AIR SERVICE LTD',
  BF: 'Vincent Aviation',
  BG: 'Biman Bangladesh',
  BH: 'BH Airlines (Air Bosna)',
  BI: 'Royal Brunei Air',
  BB: 'Seaborne Airlines',
  BD: 'Bmi British Midland',
  BE: 'Flybe',
  C0: 'Centralwings',
  BP: 'Air Botswana',
  C2: 'CEIBA Intercontinental',
  BQ: 'Aeromar Airlines',
  BJ: 'Nouvelair Tunisie',
  BL: 'Jetstar Pacific',
  BM: 'Airbee',
  CZ: 'China Southern',
  CY: 'Cyprus Airways',
  CX: 'Cathay Pacific Airways',
  D8: 'Norwegian Air',
  D7: 'AirAsia X',
  CV: 'Air Chatham',
  D6: 'Interair South Africa',
  CU: 'Cubana Airlines',
  D5: 'Dauair',
  D4: 'Alidaunia',
  CS: 'Continental Micronesia',
  DC: 'Golden Air Commuter',
  DB: 'Brit Air',
  CI: 'China Airlines',
  CJ: 'BA City Flyer',
  CG: 'Airlines of Papua New Guinea',
  CH: 'Bemidji Airlines',
  CE: 'Nationwide Air',
  CF: 'City Airline',
  CD: 'Yining Arpt',
  D2: 'Alliance Air (India)',
  CQ: 'Severstal Aircompany',
  D3: 'Sunshine Express Airline',
  CO: 'Daallo Airlines',
  CP: 'Continental Airlines',
  CM: 'Compass Airlines',
  CN: 'Copa Airlines',
  CL: 'Grand China Air',
  LW: 'Lufthansa CityLine',
  LV: 'Pacific Wings',
  M7: 'Albanian Airlines',
  LU: 'Marsland Aviation',
  M5: 'Kenmore Air',
  LZ: 'Belle Air',
  LY: 'El Al Israel Airlines',
  LX: 'Swiss AirLines',
  M9: 'Motor Sich JSC',
  LO: 'LOT Polish Airlines',
  M0: 'Aero Mongolia',
  LN: 'Libyan Airlines',
  M4: 'AVIOMPEX',
  LS: 'Jet2.com',
  LR: 'LACSA',
  M3: 'North Flying',
  M2: 'Mahfooz Aviation (Gambia) Ltd.',
  LQ: 'Air Guinea Cargo',
  LP: 'Lan Peru S.A.',
  MH: 'Malaysia Airline',
  ME: 'Middle East Airlines',
  MF: 'Xiamen Airlines',
  MK: 'Air Mauritius',
  ML: 'African Transport',
  MI: 'SilkAir',
  MJ: 'Mihin Lanka',
  MD: 'Air Madagascar',
  MA: 'Malev Hungarian Airlines',
  MV: 'Armenian International Airways',
  N7: 'Lagun Air',
  MU: 'China Eastern Airlines',
  N6: 'Nuevo Continente S.A.',
  N9: 'Niger Air Continental',
  MW: 'Mokulele Airlines',
  MN: 'Kulula air',
  MM: 'Sociedad Aeronautica Medellin',
  MP: 'Martinair Holland',
  MO: 'Calm Air International',
  N3: 'Omskavia Airlines',
  N2: 'Dagestan Airlines',
  MQ: 'American Eagle Airlines',
  MT: 'Thomas Cook Airlines',
  MS: 'Egyptair',
  N4: 'Trans Air Benin',
  NF: 'Air Vanuatu Limited',
  NG: 'Lauda Air Luftfahrt',
  NH: 'All Nippon Airways',
  NK: 'Spirit Airlines',
  NL: 'Shaheen Air International',
  NM: 'Manx2',
  NB: 'Sterling',
  NZ: 'Air New Zealand',
  NY: 'Air Iceland',
  NX: 'Air Macau Company Limited',
  NW: 'Northwest Airlines Inc',
  O8: 'Oasis Hong Kong Airlines',
  NV: 'Air Central',
  O7: 'OzJet Airlines',
  NU: 'Japan Trans Ocean Air',
  NT: 'Binter Canarias',
  NS: 'Northeastern Airlines',
  O4: 'Antrak Air Ltd',
  NR: 'Pamir Air',
  NQ: 'Air Japan',
  O2: 'Jet Air',
  NO: 'Neos',
  NN: 'VIM Airlines',
  OM: 'MIAT - Mongolian Airlines',
  ON: 'Our Airline',
  OK: 'Czech Airlines',
  OL: 'OLT Ostfriesische Lufttransport',
  OJ: 'Overland Airways',
  OH: 'Comair Inc.',
  OF: 'Air Finland',
  OC: 'Omni',
  OA: 'Olympic Air',
  OX: 'Orient Thai Airlines',
  P9: 'Perm Airlines',
  OW: 'Executive Airlines, Inc.',
  P8: 'P.L.A.S. S/A',
  OZ: 'Asiana Airlines',
  OY: 'Andes Lineas Aeras',
  OT: 'Aeropelican',
  P5: 'AeroRepublica',
  OS: 'Austrian Airlines',
  P4: 'Aero Lineas Sosa',
  OV: 'Salam Air',
  P6: 'Pascan Aviation',
  OU: 'Croatia Airlines',
  OO: 'Skywest Airlines (Utah)',
  P0: 'ProflightCommuter Services',
  OR: 'Tui Airlines Nederland',
  P2: 'AirKenya Express',
  OQ: 'Chongqing Airlines',
  PL: 'Southern Air Charter',
  PN: 'China West Air',
  Q0: 'Quebecair Express',
  PO: 'Polar Air Cargo',
  PH: 'Polynesian Airlines',
  PJ: 'Air Saint-Pierre',
  PD: 'Porter Airlines',
  PF: 'Primera Air Scandinavia',
  PG: 'Bangkok Airways',
  PB: 'Provincial Airlines',
  HK: 'Yangon Airways',
  HH: 'Islandsflug HF',
  HI: 'Papillon Airways Inc',
  HN: 'Heavylift Cargo Airlines',
  HO: 'Juneyao Airlines',
  HM: 'Air Seychelles',
  HR: 'Hahn Air Businessline',
  I3: 'Ivoirienne de Transport',
  HS: 'Svenska Direktflyg',
  HQ: 'Harmony Airways',
  HV: 'Transavia Airlines',
  I8: 'Aboriginal Air Services',
  HW: 'North-Wright Air Ltd',
  I5: 'Air India Express',
  HU: 'Hainan Airlines',
  HZ: 'Sakhalinskie Aviatrassy',
  HY: 'Uzbekistan Airways',
  I9: 'Air Italy',
  HX: 'Hong Kong Airlines',
  IC: 'Indian Airlines',
  IB: 'Iberia',
  IA: 'Iraqi Airways',
  IH: 'Falcon Air',
  IG: 'Meridiana Fly S.p.a',
  IF: 'Islas Airways',
  IE: 'Solomon Airlines',
  IJ: 'GREAT WALL AIRLINES CO LTD',
  IO: 'Intercontinental Pacific Airways',
  J0: 'Jetlink Express',
  IP: 'Atyrau Airways',
  J2: 'Azerbaijan Airlines',
  IQ: 'Augsburg Airways',
  J3: 'Northwestern Air',
  IR: 'Iran Air',
  IS: 'Island Airlines of Nantucket',
  J5: 'Alaska Seaplane',
  J6: "Larry's Flying Service",
  J7: 'Centre-Avia Airlines',
  IV: 'Wind Jet',
  J8: 'Berjaya Air',
  IW: 'Wings Air',
  J9: 'Jazeera Airways',
  IX: 'Air India Express',
  IZ: 'Arkia Israeli Airlines',
  IY: 'Yemenia Yemen Airways',
  JA: 'B & H Airlines',
  JC: 'JAL Express',
  JE: 'Mango',
  JD: 'Deer Air Co',
  JF: 'L A B Flying Service',
  JI: 'San Juan Aviation',
  JH: 'Nordeste-Linhas Aereas Regionals',
  JP: 'Adria Airways',
  K2: 'Eurolot S. A.',
  JQ: 'Jetstar Airways',
  JN: 'Excel Airways',
  JO: 'JALways',
  JL: 'Japan Airlines International',
  JM: 'Air Jamaica',
  JJ: 'TAM Linhas Aereas',
  JK: 'Spanair',
  K9: 'Esen Air',
  JY: 'Air Turks & Caicos',
  JV: 'Bearskin Airlines',
  K5: 'Wings of Alaska',
  JT: 'Lion Air',
  JU: 'JAT Airways',
  K3: 'Taquan Air Service',
  JR: 'Aero California',
  K4: 'Kronflyg',
  JS: 'Air Koryo',
  KB: 'Druk Air',
  KA: 'Hong Kong Dragon Airlines',
  JZ: 'Skyways AB',
  KG: 'Aerogaviota',
  KF: 'Blue1',
  KE: 'Korean Air',
  KC: 'Air Astana',
  KO: 'Alaska Central Express',
  KP: 'Kiwi International',
  KQ: 'Kenya Airways',
  KR: 'Comores Aviation',
  KK: 'Atlas Jet International Airways',
  KL: 'KLM',
  KL1: 'KLM',
  KM: 'Air Malta Company',
  KW: 'Wataniya Airlines',
  KX: 'Cayman Airways',
  L9: 'Teamline Air Luftfahrt',
  L4: 'Air Liaison',
  KS: 'Peninsula Airways',
  L5: 'Helikopter Service',
  KT: 'Katmai Air',
  L6: 'Tbilaviamsheni',
  KU: 'Kuwait Airways',
  LA: 'Lan Airlines S.A.',
  LB: 'Air Costa',
  LI: 'Liat Ltd',
  LH: 'Lufthansa',
  LH1: 'Lufthansa',
  LJ: 'Jin Air',
  LE: 'Lugansk Airlines',
  LG: 'Luxair',
  LF: 'Airblue',
  PA: 'AirBlue',
  VT: 'Air Tahiti',
  W5: 'Mahan Air',
  W6: 'Wizz Air Hungary',
  VU: 'Air Ivoire',
  W3: 'Arik Air',
  VR: 'Transportes Aereos de Cabo Verde',
  VS: 'Virgin Atlantic',
  VQ: 'Vintage Props & Jets Inc',
  VN: 'Vietnam Airlines',
  VO: 'Tyrolean Airways',
  VJ: 'Vietjet Aviation',
  VK: 'Virgin Nigeria Airways',
  VH: 'Aeropostal Alas De Venezuela',
  VI: 'Vieques Air Link',
  VF: 'Valuair LTD',
  VG: 'VLM Trading As Cityjet',
  VE: 'Volare Spa',
  VC: 'Ocean Airlines SPA',
  VA: 'V-Australia',
  UZ: 'Buraq Air',
  V9: 'Bashkir Airlines',
  UX: 'Air Europa',
  UW: 'Universal Airlines Inc',
  V8: 'Iliamna Air Taxi',
  V6: 'VIP S.A',
  UU: 'Air Austral',
  V3: 'Carpatair',
  US: 'US Airways',
  UT: 'UTAir Aviation JSC',
  V5: 'DANUBE WINGS',
  UM: 'Air Zimbabwe',
  UN: 'Transaero Airlines',
  UO: 'Hong Kong Express Airways',
  UP: 'Bahamasair',
  UI: 'Eurocypria Airlines',
  UJ: 'Montair Aviation',
  UL: 'SriLankan Airlines',
  UL1: 'SriLankan Airlines',
  UE: 'Nasair',
  UF: 'Ukrainian Mediterranean',
  UG: 'Sevenair',
  UA: 'United',
  UD: 'Hex Air',
  UC: 'Lan Chile Cargo',
  TY: 'Air Caledonie',
  TX: 'Air Caraibes',
  U9: 'Tatarstan Airlines',
  TU: 'Tunis Air',
  U6: 'Ural Airlines',
  TT: 'Tiger Airways',
  U5: 'USA 3000 Airlines',
  U8: 'Armavia Airline',
  U7: 'Air Uganda',
  Y3: 'Driessen Services',
  XR: 'Skywest Airlines (Australia)',
  Y4: 'Volaris',
  XP: 'Casino Express Airlines',
  XQ: 'SunExpress',
  XV: 'MR Lines',
  XW: 'Sky Express',
  Y8: 'Yakutia',
  Y5: 'Pace Airlines',
  PK: 'Pakistan Airlines',
  XT: 'Skystar Airways',
  XU: 'African Express Airways',
  XJ: 'Mesaba Aviation',
  XK: 'CCM Airlines',
  XN: 'Air Nepal International',
  Y0: 'Yellow Air Taxi',
  XO: 'LTE International Airways',
  XL: 'Lan Ecuador Aerolane SA',
  XM: 'Alitalia Express',
  XG: 'Clickair',
  XF: 'Vladivostok Air',
  XE: 'Express Jet Airlines',
  WY: 'Oman Aviation',
  WX: 'City Jet',
  WW: 'Bmibaby',
  X8: 'Icaro',
  WO: 'World Airways',
  WP: 'Island Air',
  WR: 'Aviaprad',
  X3: 'Tuifly',
  WS: 'WestJet',
  X4: 'Vanair Limited',
  WT: 'Wasaya Airways',
  X5: 'Afrique Airlines',
  WU: 'Wizz Air Ukraine',
  X7: 'Air Service',
  WG: 'Sunwing Airlines',
  WI: 'Tradewinds Airlines',
  WJ: 'Labrador Airways Limited',
  WK: 'Edelweiss Air',
  WM: 'Windward Island Airways',
  WN: 'Southwest Airlines',
  WB: 'Rwandair Express',
  WA: 'KLM Cityhopper B V',
  WC: 'Islena Airlines',
  WF: 'Wideroes Flyveselskap',
  VW: 'Aeromar Airlines',
  VV: 'Aerosvit Airlines',
  VY: 'Vueling Airlines',
  VX: 'Virgin America',
  VZ: 'My TravelLite',
  RI: 'PT. Mandella Airlines',
  RH: 'Robin Hood Aviation',
  RF: 'Florida West International Airways',
  RE: 'Aer Arann Express',
  RB: 'Syrian Arab Airlines',
  S2: 'Jet Lite',
  RQ: 'Kam Air',
  RP: 'Chautauqua Airlines',
  S0: 'Slok Air International',
  RO: 'Tarom-Romanian Air Transport',
  RM: 'Regional Air',
  RJ: 'Royal Jordanian',
  QW: 'Blue Wings',
  QX: 'Horizon Air - Seattle',
  R9: 'Camai Air',
  R6: 'DOT LT',
  QV: 'Lao Aviation',
  R7: 'Aserca Airlines',
  QS: 'Smartwings',
  R4: 'Tulpar Avia Service',
  QT: 'Regional Pacific Airlines',
  R5: 'Malta Air Charter Company Limited',
  QQ: 'Alliance Airlines',
  R2: 'Orenair',
  QR: 'Qatar Airways',
  QR1: 'Qatar Airways',
  RA: 'Royal Nepal Airlines',
  QY: 'EUROPEAN AIR',
  QZ: 'Indonesia AirAsia',
  QF: 'Qantas Airways',
  QF1: 'Qantas Airways',
  QE: 'Crossair Europe',
  QH: 'Kyrgystan',
  QG: 'Qualiflyer Group',
  QA: 'Aero Caribe',
  QC: 'Air Corridor',
  QM: 'Air Malawi',
  QO: 'Origin Pacific Airways',
  QJ: 'Latpass Airlines',
  QI: 'Cimber Sterling',
  QL: 'Laser Airlines',
  QK: 'Air Canada Jazz',
  Q5: 'Forty Mile Air',
  PU: 'Pluna',
  PV: 'Saint Barth Commuter',
  PW: 'Precisionair',
  Q8: 'Trans Air Congo',
  PP: 'Jet Aviation Business Jets',
  PQ: 'Panafrican Airways',
  PR: 'Philippine Airlines',
  PS: 'Ukraine International Airline',
  Q4: 'Swazi Express Airways',
  PX: 'Air Niugini',
  PY: 'Surinam Airways',
  PZ: 'Transportes Aereso del Mercosur',
  TG: 'Thai Airways Intl',
  TF: 'Malmo Aviation',
  TD: 'Atlantis European Airways',
  TK: 'Turkish Airlines',
  TH: 'British Airways Citiexpress',
  TN: 'Air Tahiti Nui',
  TM: 'LAM Lineas Aereas de Mocambique',
  TL: 'Air North Regional',
  TS: 'Air Transat A.T. Inc.',
  U4: 'SCOOT PTE.LTD',
  TR: 'Buddha Air',
  U3: 'Tiger Airways',
  TQ: 'Avies LTD',
  U2: 'Tandem Aero',
  TP: 'Easy jet',
  SU: 'TAP Air Portugal',
  SV: 'Aeroflot',
  T7: 'Saudi Arabian Airlines',
  SS: 'Twin Jet',
  T5: 'Corsair International',
  SY: 'Turkmenistan Airlines',
  SZ: 'Sun Country Airlines',
  T8: 'Air Southwest',
  SW: 'STA Trans African Airlines',
  T9: 'Air Namibia',
  TB: 'Trans Meridian Airlines',
  TC: 'Tui Airlines Belgium',
  TA: 'Taca International Airlines',
  SD: 'Sudan Airways',
  SC: 'Shandong Airlines',
  SF: 'Tassili Airlines',
  SE: 'XL Airways France',
  SG: 'Spice Jet',
  SJ: 'Sriwijaya Air',
  SI: 'Skynet Airlines',
  SL: 'Thai lion',
  SK: 'SAS Scandinavian Airlines',
  SN: 'Brussels Airlines',
  SM: 'Swedline',
  SP: 'SATA Air Acores',
  T3: 'Eastern Airways Ltd',
  SQ: 'Singapore Airlines',
  T2: 'Nakina Air Service',
  RR: 'Royal Air Force-38 Transport Group',
  S3: 'Santa Barbara Airlines C.A.',
  S4: 'SATA International',
  RT: 'RAK Airways',
  S5: 'Star Air',
  S6: 'Salmon Air',
  S7: 'Siberian Airlines',
  RV: 'Caspian Airlines',
  RW: 'Royal Air Charter Service Inc',
  RY: 'Royal Wings',
  SA: 'South African Airways',
  SA1: 'South African Airways',
  SB: 'Air Calin',
  ZA: 'One Ticket to the World',
  ZG: 'Astair',
  ZH: 'Viva Macau',
  ZI: 'Shenzhen Airlines',
  ZN: 'Aigle Azur',
  ZP: 'Naysa',
  ZK: 'Air St Thomas',
  ZJ: 'Great Lakes Airlines',
  ZL: 'Zambezi Airlines',
  ZW: 'Regional Express',
  ZV: 'Air Wisconsin',
  ZM: 'Air Midwest',
  ZY: 'Ada Air',
  ZX: 'Zoom Airlines UK',
  ZR: 'Alexandria Airlines',
  ZU: 'Helios Airways',
  XZ: 'South African Express',
  Y9: 'Kish Airlines',
  YH: 'West Caribbean Airways',
  YE: 'Eram Airlines',
  YC: 'Yamal Airlines',
  YD: 'Mauritania Airways',
  YB: 'South African Express',
  YO: 'Heli-Air Monaco',
  YN: 'Air Creebec',
  YM: 'Montenergo Airlines',
  YL: 'Air Bissau International',
  YJ: 'AMC Airlines',
  YI: 'Air Sunshine',
  YW: 'Air Nostrum',
  YV: 'Mesa Airlines Inc',
  Z6: 'Dnieproavia State Aviation',
  YT: 'Air Togo',
  Z5: 'GMG Airlines',
  YS: 'Regional CAE',
  Z4: 'Zoom Airlines',
  YR: 'Scenic Airlines',
  Z3: 'PM Air LLC',
  Z2: 'Airasia Philippine',
  YQ: 'Aircompany Polet',
  '3A': 'Alliance Airlines (Chicago)',
  '3B': 'Job Air Central Connect',
  '2U': "Sun d'OR Int'l Airlines",
  '2X': 'XEROX',
  '2Y': 'Air Andaman',
  '2W': 'Welcome Air',
  '3M': 'Gulfstream Intl',
  '3L': 'Intersky',
  '3K': 'Jetstar Asia Airways',
  '3R': 'Gromov Air',
  '3Q': 'Carib Aviation',
  '3O': 'Peau Vava U',
  '3F': 'Pacific Airways',
  '3E': 'Air Choice One',
  '3D': 'Denim Air',
  '3C': 'Corporate Express Airlines',
  '3H': 'Air Inuit Ltd.',
  '1T': '1Time Airlines',
  '1X': 'Branson Air Express',
  '2K': 'Aerogal Aerolinas Galapagos',
  '2J': 'Air Burkina',
  '2M': 'Moldavian Airlines',
  '2L': 'Helvetic Airways',
  '2O': 'Island Air Service',
  '2Q': 'Avitrans Nordi',
  '2B': 'Bahrain Air',
  '2E': 'Smokey Bay Air',
  '2G': 'Northwest Seaplanes',
  '2F': 'Frontier Flying Service',
  '2I': 'Star Up',
  '0Y': 'FlyYeti',
  '0D': 'Darwin Airlines',
  '6Y': 'Latcharter Airlines Ltd',
  '7B': 'Atlant-Soyuz Airlines',
  '7A': 'Air Next',
  '7F': 'First Air',
  '7E': 'Panagra Airways Inc.',
  '7D': 'Donbassaero Airlines',
  '7I': 'Insel Air International',
  '7J': 'Tajikair',
  '7H': 'Era Aviation Inc',
  '7N': 'Inland Aviation Services',
  '7Q': 'Tibesti AirLibya',
  '7R': 'Red Sea Air',
  '7P': 'APA International Air SA',
  '7V': 'Pelican Air',
  '7S': 'Artic Transportation Services',
  '7T': 'Trans North Aviation',
  '5V': 'Lviv Airlines',
  '5U': 'Challenge Aero',
  '5W': 'Astraeus',
  '5Z': 'Bismillah Airlines',
  '6C': 'Cape Smythe Air',
  '6E': 'Indigo',
  '6G': 'Gulfstream Connection',
  '6H': 'Israir',
  '6I': 'AeroSyncro Aviation',
  '6J': 'Jubba Airways',
  '6K': 'Asian Spirit',
  '6L': 'Aklak Air Ltd',
  '6N': 'Nordic Regional',
  '6P': 'Clubair Sixgo',
  '6Q': 'Slovak Airlines',
  '6T': 'Air Mandalay Ltd.',
  '4Y': 'Yute Air Alaska Inc.',
  '4W': 'Warbelows Air Ventures',
  '4V': 'Birdy Airlinesce',
  '4U': 'Germanwings',
  '4T': 'Belair',
  '5D': 'Aeromexico Connect',
  '5C': 'Nature Air',
  '5B': 'Euro- Asia Air International',
  '5K': 'Odessa Airlines',
  '5L': 'Aerosur',
  '5J': 'Cebu Pacific Air',
  '5G': 'Skyservice Airlines',
  '5H': 'Five Fourty Aviation',
  '5E': 'Nok Mini',
  '5F': 'Arctic Circle Air',
  '5S': 'Servicios Aereos Profesionales',
  '5T': 'Canadian North',
  '5Q': 'Best Air',
  '5O': 'Europe Airpost',
  '5P': 'SkyEurope Airlines Hungary',
  '5N': 'Nordavia Regional Airline',
  '3X': 'JAPAN AIR COMMUTER CO',
  '3Z': 'Everts Air',
  '3Y': 'UNIWAYS',
  '3S': 'Air Guyane',
  '3U': 'Sichuan Airlines',
  '4A': 'Royal Bengal Airlines',
  '4C': 'Aires',
  '4B': 'Perimeter Aviation',
  '4H': 'United Airways Bangladesh',
  '4I': 'IHY Izmir Havayollari',
  '4J': 'Somon Air',
  '4K': 'Kenn Borek Air Ltd',
  '4D': 'Air Sinai',
  '4F': 'Air City',
  '4G': 'Gazpromavia',
  '4P': 'Viking Airlines',
  '4Q': 'Safi Airways',
  '4Q1': 'Safi Airways',
  '4R': 'Hamburg International',
  '4L': 'Georgian International Airline LLC',
  '4M': 'Lan Argentina',
  '4N': 'Air North',
  '4O': 'Interjet',
  '9V': 'Avior Airlines',
  '9U': 'Air Moldova',
  '9X': 'New Axis Airways',
  '9W': 'Jet Airways',
  '9W1': 'Jet Airways',
  '9Q': 'PB Air Company',
  '9T': 'Travelspan',
  '9N': 'SATENA',
  '9M': 'Central Mountain Air',
  '9P': 'Palau National Airlines',
  '9J': 'Pacific Island Aviation',
  '9L': 'Colgan Air',
  '9K': 'Cape Air',
  '9E': 'Nortwest Airlink',
  '9H': 'Dutch Antilles Express',
  '9C': 'Wimbi Dira Airways',
  '9D': 'Toumai Air Tchad',
  '8Z': 'Wizz Air Bulgaria',
  '8W': 'Private Wings',
  '8V': 'Wright Air Service Inc.',
  '8U': 'Afriqiyah Airways',
  '8T': 'Air Tindi Ltd.',
  '8P': 'Pacific Coastal Airlines',
  '8N': 'Nordkalottflyg',
  '8M': 'Myanmar Airways Intl',
  '8J': 'Jet4You',
  '8H': 'Highland Airways',
  '8F': 'STP Airways',
  '8D': 'Servant Air, Inc',
  '8E': 'Bering Air Inc.',
  '8A': 'Atlas Blue',
  '7Y': 'Flying Carpet Air Transport',
  '7Z': 'Halcyon Air',
  '7W': 'Wind Rose Aviation',
  SG9: 'Spice Jet',
  UK: 'Vistara',
  U22: 'U2',
  DY2: 'DY',
  VY2: 'VY',
  OP: 'Air Pegasus',
  YK: 'Avia Traffic Company',
  GK: 'Jetstar Japan',
  K6: 'Cambodia Angkor Air',
  '2T': 'Trujet',
  OD: 'Malindo Air',
  UB: 'Myanmar National Airlines',
  RX: 'REGENT AIRWAYS',
  K7: 'AIR KBZ',
  NA: 'SUPREME AIRLINE',
  AD: 'Azul Linhas Aereas Brasileiras',
  XY: 'Flynas',
  H1: 'Hahn Air Systems',
  SG2: 'Spicejet Coupon',
  SG3: 'Spicejet Special',
  '7C': 'Jeju Airline',
  OG: 'STAR AIR',
  S9: 'FlyBig',
  QP: 'Akasa Air',
  '9I': 'Alliance Air',
  WE: 'THAI SMILE AIRWAYS',
  UR: 'UGANDA NATIONAL AIRLINES',
};

export default AIRLINE_NAMES_FOR_CARRIER_CODE;
